import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  IconButton,
  MenuCloseIcon,
} from '@noor/ui';

export function BranchImagePreview({
  src,
  alt,
  open,
  onOpenChange,
}: {
  src: string | undefined;
  alt: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  if (!src) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        closeOnInteractOutside
        showClose={false}
        aria-label={alt}
        className="inset-0 top-0 left-0 flex h-screen w-screen max-w-none translate-x-0 translate-y-0 items-center justify-center border-0 bg-transparent p-4 shadow-none sm:max-w-none"
      >
        <IconButton
          variant="ghost"
          aria-label="Close image preview"
          onClick={() => onOpenChange(false)}
          className="absolute top-4 right-4 z-10 size-11 rounded-full bg-black/45 text-white hover:bg-black/65 hover:text-white"
        >
          <MenuCloseIcon className="size-6" />
        </IconButton>
        <DialogTitle className="sr-only">{alt}</DialogTitle>
        <DialogDescription className="sr-only">
          Full-size image preview.
        </DialogDescription>
        <img
          src={src}
          alt={alt}
          className="max-h-[90vh] w-auto max-w-full object-contain"
        />
      </DialogContent>
    </Dialog>
  );
}
